import React from 'react';

import { formatDateTime, formatDateMonthYear, formatDate } from '@klp/helpers';

import './DateTime.scss';

enum DateTimeFormat {
    Date = 'Date',
    DateTime = 'DateTime',
    DayMonthYear = 'DayMonthYear',
}
interface IDateTime {
    date?: Date | string | null;
    format?: DateTimeFormat;
}

export type IDateTimeProps = IDateTime;

export const DateTime: React.FC<IDateTimeProps> & {
    format: typeof DateTimeFormat;
} = (props) => {
    const { date, format, ...restProps } = props;
    const dateFormat = format ?? DateTimeFormat.Date;

    if (!date) {
        return null;
    }

    let formatted = '';
    switch (dateFormat) {
        case DateTimeFormat.DateTime:
            formatted = formatDateTime(date);
            break;
        case DateTimeFormat.DayMonthYear:
            formatted = formatDateMonthYear(date);
            break;
        default:
            formatted = formatDate(date);
            break;
    }

    return (
        <span className="DateTime" {...restProps}>
            {formatted}
        </span>
    );
};

DateTime.format = DateTimeFormat;
DateTime.displayName = 'DateTime';
